import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./utils/authConfig";
import { clearAuthState, initializeFetcher } from "./utils/fetcher";

const msalInstance = new PublicClientApplication(msalConfig);

const msalInitPromise = msalInstance.initialize().then(() => {
  console.log("MSAL initialized successfully");
}).catch((error) => {
  console.error("MSAL initialization failed:", error);
});

initializeFetcher(
  msalInstance,
  msalInitPromise,
  async () => {
    console.log("Authentication error - redirecting to login");
    await clearAuthState();
    window.location.href = "/login";
  },
);

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App instance={msalInstance} />
  </React.StrictMode>,
);
